export default __webpack_public_path__ + "static/media/EmailVerificationIcon.7c986087.svg";